import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

export const PhotoProcessing: React.FC<EmptyProps> = () => {
	return (
		<div aria-hidden="true" className="overflow-hidden">
			<div className="flex aspect-video h-full items-center justify-center overflow-hidden">
				<Spinner className="size-4" />
			</div>
		</div>
	);
};
